import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell, ICellError } from '.'

export interface IArrayColumn extends ITableColumn {
  Settings: null
}

export interface IArrayCell extends ICell {
  settings: null
}

export class ArrayCell implements IArrayCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value instanceof Date) {
      return this.value.toISOString() // converting Date to ISO string
    }

    if (typeof this.value === 'object' && this.value !== null && 'message' in this.value) {
      return (this.value as ICellError).message // assuming ICellError has a message property
    }

    return this.value?.toString() ?? '' // Fallback to calling toString on primitive values or return empty string if null
  }

  toCell<T extends Cell>(newValue: T) {
    if (!Array.isArray(newValue) || !newValue.length) {
      this.value = []
      return this
    }

    this.value = newValue
    return this
  }
}
